import Component from "./WellnessPaymentsStripe";

export default Component;
